<template>
  <div>
    <el-dialog
      title="账号信息"
      :visible.sync="dialogVisible"
      width="840px"
      :before-close="handleClose"
      :destroy-on-close="true"
      :append-to-body="true"
    >
      <el-tabs v-model="active" type="border-card" @tab-click="tabClick">
        <el-tab-pane label="个人信息" name="个人信息">
          <div class="container">
            <h4>个人信息</h4>
            <div class="conForm">
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="120px"
                :inline="inline"
              >
                <el-form-item label="手机号码：" prop="mobile" required>
                  <el-input
                    v-model.number="form.mobile"
                    autocomplete="off"
                    placeholder="请输入手机号码"
                    readonly
                  >
                    <template #suffix>
                      <el-button
                        v-if="!activeIndex"
                        type="text"
                        icon="el-icon-edit-outline"
                        class="elleft"
                        @click="editForm('mobile')"
                      ></el-button> </template
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="新手机号码："
                  prop="nphone"
                  v-if="activeIndex == 'mobile'"
                  key="nphone"
                >
                  <el-input
                    v-model.number="form.nphone"
                    autocomplete="off"
                    placeholder="请输入新手机号码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="验证码：" prop="code" v-if="activeIndex == 'mobile'">
                  <el-input v-model="form.code" placeholder="请输入验证码">
                    <template #suffix>
                      <div v-if="messageCodeVis" class="second-text">
                        {{ countdown }}秒后重新获取
                      </div>
                      <el-button v-else type="text" link @click="sendCode"
                        >获取验证码</el-button
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="登录密码："
                  prop="pwd"
                  v-if="activeIndex != 'mobile'"
                  :rules="[
                    {
                      required: activeIndex == '' ? false : true,
                      message: '请输入登录密码',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="form.pwd"
                    autocomplete="off"
                    placeholder="请输入密码"
                    type="password"
                    :readonly="activeIndex == ''"
                  >
                    <template #suffix>
                      <el-button
                        v-if="!activeIndex"
                        type="text"
                        icon="el-icon-edit-outline"
                        class="elleft"
                        @click="editForm('pwd')"
                      ></el-button> </template
                  ></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newpsd" v-if="activeIndex == 'pwd'">
                  <el-input
                    v-model="form.newpsd"
                    autocomplete="off"
                    placeholder="请输入新密码"
                    type="password"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="spsd" v-if="activeIndex == 'pwd'">
                  <el-input
                    v-model="form.spsd"
                    autocomplete="off"
                    placeholder="再次输入密码"
                    type="password"
                  ></el-input>
                </el-form-item>
                <div style="text-align: center" v-if="activeIndex">
                  <el-button @click="handleCancleForm">取 消</el-button>
                  <el-button type="primary" @click="handleConfirmForm">保存</el-button>
                </div>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="邮寄信息" name="邮寄信息">
          <div class="container">
            <h4>邮寄信息</h4>
            <div class="conForm">
              <div class="addAddress" v-if="!addressShow" @click="handlerAddAddress">
                +新增地址
              </div>
              <el-form
                ref="addressForm"
                :model="addressForm"
                :rules="addressRules"
                :inline="inline"
                label-width="150px"
                v-if="addressShow"
              >
                <el-form-item label="收货人名称：" prop="mailname">
                  <el-input
                    v-model="addressForm.mailname"
                    placeholder="收货人名称"
                    class="formInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收货人手机号码：" prop="mailmobile">
                  <el-input
                    v-model.number="addressForm.mailmobile"
                    autocomplete="off"
                    placeholder="手机号码"
                    class="formInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="省/市/区：" prop="areacode">
                  <my-cascader
                    placeholder="省/市/区"
                    :data="options"
                    v-model="addressForm.areacode"
                    2way="cityname"
                    :cityname.sync="addressForm.areaname"
                    showAllLevels
                    :props="{ label: 'cityname', value: 'citycode' }"
                  >
                  </my-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                  <el-input
                    v-model="addressForm.address"
                    placeholder="请输入"
                    class="formInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="默认地址" prop="state">
                  <el-radio-group v-model="addressForm.isdefault">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div style="text-align: center" v-if="addressShow">
                <el-button @click="handleCancleAddress">取 消</el-button>
                <el-button type="primary" @click="handleConfirmAddress">保存</el-button>
              </div>
              <div v-if="!addressShow">
                <div v-for="item in addressList" :key="item.rowguid" class="listAddress">
                  <div class="itemRow">
                    <div class="fLeft" style="width: calc(100% - 70px); font-size: 15px">
                      <div>{{ item.mailname }}</div>
                      <div>{{ item.mailmobile }}</div>
                    </div>
                    <div v-if="item.isdefault == '1'" class="defaultAddress">
                      默认地址
                    </div>
                  </div>
                  <div class="itemRow">
                    <div class="fLeft">
                      <div>{{ item.areaname }}{{ item.address }}</div>
                    </div>
                    <div class="fLeft">
                      <div class="operate" @click="editMail(item)">编辑</div>
                      <div class="operate" @click="delMail(item)">删除</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></el-tab-pane
        >
        <el-tab-pane label="发票信息" name="发票信息">
          <div class="container">
            <h4>发票信息</h4>
            <div class="conForm">
              <div class="addAddress" @click="handlerAddInvoice" v-if="invoiceAdd">
                +新增发票信息
              </div>
              <div v-if="invoiceEdit">
                <el-form
                  ref="invoiceForm"
                  :model="invoiceForm"
                  :rules="invoiceRules"
                  :inline="inline"
                  label-width="150px"
                >
                  <el-form-item label="单位名称：" prop="dwname">
                    <el-input
                      v-model="invoiceForm.dwname"
                      placeholder="请输入单位名称"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="统一社会信用代码：" prop="creditcode">
                    <el-input
                      v-model="invoiceForm.creditcode"
                      placeholder="请输入统一社会信用代码"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开户行：" prop="khbank">
                    <el-input
                      v-model="invoiceForm.khbank"
                      placeholder="请输入开户行"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="账号：" prop="zhanghao">
                    <el-input
                      v-model.number="invoiceForm.zhanghao"
                      autocomplete="off"
                      placeholder="请输入账号"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="地址：" prop="address">
                    <el-input
                      v-model="invoiceForm.address"
                      placeholder="请输入地址"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="电话：" prop="phone">
                    <el-input
                      v-model.number="invoiceForm.phone"
                      autocomplete="off"
                      placeholder="请输入手机号码"
                      class="formInput"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div style="text-align: center">
                  <el-button @click="handleCancleInvoice">取 消</el-button>
                  <el-button type="primary" @click="handleConfirmInvoice">保存</el-button>
                </div>
              </div>
              <div v-if="invoiceShow">
                <div v-for="item in invoiceList" :key="item.rowguid" class="listAddress">
                  <div class="itemRow">
                    <div class="fLeft" style="width: calc(100% - 70px); font-size: 15px">
                      <div>{{ item.dwname }}</div>
                      <div>{{ item.phone }}</div>
                    </div>
                  </div>
                  <div class="itemRow">
                    <div class="fLeft">
                      <div>{{ item.khbank }}</div>
                    </div>
                    <div class="fLeft">
                      <div class="operate" @click="editInvoice">编辑</div>
                      <div class="operate" @click="delInvoice(item)">删除</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { options } from "~/assets/js/city";
import { mapGetters, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        if (!reg.test(value)) {
          callback(new Error("密码为不少于6位的数字字母组合"));
        } else {
          // if (this.form.newpsd !== "") {
          //   this.$refs.form.validateField("newpsd");
          // }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        if (!reg.test(value)) {
          callback(new Error("确认密码为不少于6位的数字字母组合"));
        } else if (value !== this.form.newpsd) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: true,
      inline: false,
      active: "个人信息",
      //个人信息
      readonly: true,
      form: {
        mobile: "",
        nphone: "",
        pwd: "",
        oldpsd: "",
        newpsd: "",
        spsd: "",
        code: "",
      },
      rules: {
        nphone: [{ required: true, type: "number", validator: validatePhone }],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
        newpsd: [{ required: true, validator: validatePass, trigger: "blur" }],
        spsd: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
      editPhone: false,
      activeIndex: "",
      countdown: 60,
      messageCodeVis: false,
      // 邮寄地址
      addressForm: {},
      addressRules: {
        mailname: [{ required: true, message: "请输入收货人名称", trigger: "blur" }],
        mailmobile: [{ required: true, type: "number", validator: validatePhone }],
        areacode: [{ required: true, message: "请选择省/市/区", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        isdefault: [{ required: true, message: "请选择是否默认地址", trigger: "blur" }],
      },
      addressShow: false,
      addressList: [],
      options: [],
      //发票
      invoiceForm: {},
      invoiceRules: {
        dwname: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        creditcode: [
          { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
        ],
        khbank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        zhanghao: [{ required: true, message: "请输入账号", trigger: "blur" }],
        phone: [{ required: true, type: "number", validator: validatePhone }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      invoiceAdd: true,
      invoiceShow: false,
      invoiceList: [],
      invoiceEdit: false,
    };
  },
  computed: {
    ...mapGetters({
      getUserinfo: "userinfo/getUserinfo",
      loginStatus: "userinfo/loginStatus",
    }),
  },
  created() {
    this.options = options;
  },
  mounted() {
    this.getCity();
    this.handleOpen();
  },
  methods: {
    handleOpen(callback) {
      var user = { ...this.getUserinfo.loginUser };
      this.form.mobile = user.mobile;
      this.form.pwd = "******"; // user.pwd;
    },
    handleClose() {
      this.$emit("cancle");
    },
    handleCancle() {
      this.$emit("cancle");
    },
    tabClick({ name }) {
      if (name == "个人信息") {
      } else if (name == "邮寄信息") {
        this.queryAddressData();
      } else if (name == "发票信息") {
        this.queryInvoice();
      }
    },
    //个人信息
    editForm(type) {
      // this.form.pwd = "";
      this.form.code = "";
      if (type == "pwd") {
        this.form.pwd = "";
      } else {
        this.form.pwd = "******";
      }
      this.readonly = false;
      this.activeIndex = type;
    },
    handleCancleForm() {
      this.countdown = 60;
      this.messageCodeVis = false;
      this.activeIndex = "";
      this.form.code = "";
      // this.form.pwd = "";
      this.$refs.form.resetFields();
    },
    handleConfirmForm() {
      var that = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (that.activeIndex == "mobile") {
            that.$post(
              `${this.$store.state.api.baseUrl}/usermg/changemobile.json`,
              {
                captcha: that.form.code,
                mobile: that.form.nphone,
              },
              function (data) {
                ShowMsg("修改成功", "success");
                that.handleCancleForm();
              }
            );
          } else if (that.activeIndex == "pwd") {
            that.$post(
              `${this.$store.state.api.baseUrl}/usermg/changepwd.json`,
              {
                newpwd: that.form.newpsd,
                oldpwd: that.form.pwd,
              },
              function (data) {
                ShowMsg("修改成功", "success");
                that.handleCancleForm();
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    /* 倒计时函数 */
    startCountdown() {
      const intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(intervalId);
          this.messageCodeVis = false;
        }
      }, 1000);
    },
    sendCode() {
      // if (!this.form.nphone) return this.$message("请输入新手机号码");
      // const reg = /^1[3456789]\d{9}$/;
      // if (!reg.test(this.form.nphone)) return this.$message("请输入正确的手机号码");
      this.$post(
        `${this.$store.state.api.baseUrl}/notify/sendChangeMobileCode`,
        {
          mobile: this.form.mobile,
        },
        (data) => {
          ShowMsg("验证码已发送", "success");
          this.countdown = 60;
          this.messageCodeVis = true;
          this.startCountdown();
        }
      );
    },
    //邮寄地址
    getCity() {
      this.$get(
        `${this.$store.state.api.baseUrl}/commonreq/getarea`,
        {
          parentid: "all",
        },
        function (data) {
          this.options = arrBuildTree(data, "parentcode", "citycode");
        }
      );
    },
    queryAddressData: function () {
      this.addressList = [];
      this.$get(
        `${this.$store.state.api.baseUrl}/mailaddressmg/mailaddresslist.json`,
        function (data) {
          this.addressList = data;
        }
      );
    },
    handlerAddAddress() {
      this.addressForm = {};
      this.addressShow = true;
    },
    handleCancleAddress() {
      this.$refs.addressForm.resetFields();
      this.addressShow = !this.addressShow;
    },
    handleConfirmAddress() {
      var that = this;
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          that.$post(
            `${this.$store.state.api.baseUrl}/mailaddressmg/addmailaddress.json`,
            this.addressForm,
            function (data) {
              ShowMsg("操作成功", "success");
              that.handleCancleAddress();
              that.queryAddressData();
            }
          );
        } else {
          return false;
        }
      });
    },
    editMail(item) {
      this.$post(
        `${this.$store.state.api.baseUrl}/mailaddressmg/mailaddressdetail.json`,
        {
          rowguid: item.rowguid,
        },
        function (data) {
          this.addressForm = data;
          this.addressShow = true;
        }
      );
    },
    delMail(e) {
      var that = this;
      this.$confirm("此操作将删除该邮寄信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.delAddress(e);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delAddress: function (item) {
      this.$post(
        `${this.$store.state.api.baseUrl}/mailaddressmg/delmailaddress.json`,
        {
          rowguid: item.rowguid,
        },
        function () {
          ShowMsg("删除成功", "success");
          this.queryAddressData();
        }
      );
    },
    //发票
    queryInvoice() {
      this.invoiceList = [];
      this.$get(
        `${this.$store.state.api.baseUrl}/invoicemg/invoiceList`,
        function (data) {
          this.invoiceList = data;
          this.invoiceShow = this.invoiceList && this.invoiceList.length;
          this.invoiceAdd = !this.invoiceShow;
          this.invoiceEdit = false;
        }
      );
    },
    handlerAddInvoice() {
      this.invoiceForm = {
        dwname: "",
        creditcode: "",
        khbank: "",
        zhanghao: "",
        address: "",
        phone: "",
      };
      this.invoiceEdit = true; // !this.addressShow;
      this.invoiceAdd = false;
    },
    handleCancleInvoice() {
      this.$refs.invoiceForm.resetFields();
      this.queryInvoice();
    },
    handleConfirmInvoice() {
      var that = this;
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          that.$post(
            `${this.$store.state.api.baseUrl}/invoicemg/addInvoice`,
            this.invoiceForm,
            function (data) {
              ShowMsg("操作成功", "success");
              that.handleCancleInvoice();
              that.queryInvoice();
            }
          );
        } else {
          return false;
        }
      });
    },
    editInvoice() {
      this.invoiceForm = this.invoiceList[0];
      this.invoiceEdit = true;
      this.invoiceShow = false;
    },
    delInvoice(e) {
      var that = this;
      this.$confirm("此操作将删除该发票信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$post(
            `${this.$store.state.api.baseUrl}/invoicemg/delInvoce`,
            e,
            function (data) {
              ShowMsg("删除成功", "success");
              that.queryInvoice();
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped>
.container {
  /* max-height: 500px;
  overflow-y: auto; */
  padding-right: 10px;
}
.conForm {
  margin: 20px 0;
}
.addAddress {
  border: 1px dashed #409eff;
  padding: 14px;
  margin: 20px;
  text-align: center;
  color: #409eff;
  cursor: pointer;
}
.addAddress:hover {
  border-color: #66b1ff;
  color: #66b1ff;
}

.itemRow {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 10px 15px;
}
.listAddress {
  border: 1px dashed #409eff;
  margin: 20px;
  text-align: center;
  /* color: #409eff; */
  cursor: pointer;
}
.fLeft {
  display: flex;
}
.fLeft div {
  padding-right: 20px;
}
.defaultAddress {
  background-color: #66b1ff;
  color: white;
  position: absolute;
  right: -15px;
  top: -10px;
  padding: 2px 5px;
}
.operate {
  cursor: pointer;
  color: #409eff;
}
.operate:hover {
  color: #66b1ff;
}
.elleft {
  margin-left: 10px;
}
</style>
